import { render, staticRenderFns } from "./init_seafarer_remote.vue?vue&type=template&id=0b21fd58&scoped=true&"
import script from "./init_seafarer_remote.vue?vue&type=script&lang=js&"
export * from "./init_seafarer_remote.vue?vue&type=script&lang=js&"
import style0 from "./init_seafarer_remote.vue?vue&type=style&index=0&id=0b21fd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21fd58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b21fd58', component.options)
    } else {
      api.reload('0b21fd58', component.options)
    }
    module.hot.accept("./init_seafarer_remote.vue?vue&type=template&id=0b21fd58&scoped=true&", function () {
      api.rerender('0b21fd58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/seafarer_reg/init_seafarer_remote.vue"
export default component.exports